(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-retail-admin/rich-text/assets/javascripts/helpers/editor-to-json.js') >= 0) return;  svs.modules.push('/components/marketplace-retail-admin/rich-text/assets/javascripts/helpers/editor-to-json.js');

'use strict';

const _svs$components$marke = svs.components.marketplaceRetailAdmin.richText.helpers,
  RichTextState = _svs$components$marke.RichTextState,
  serializeForStorage = _svs$components$marke.serializeForStorage;
function editorToJson(richTextState) {
  try {
    if (richTextState instanceof RichTextState) {
      return serializeForStorage(richTextState);
    }
    return '';
  } catch (e) {
    return '';
  }
}
setGlobal('svs.components.marketplaceRetailAdmin.richText.helpers.editorToJson', editorToJson);

 })(window);